export default __webpack_public_path__ + "static/media/lyrics.f85eadd7.png";